import { useEffect } from "react";

const CANONICAL_ORIGIN = "https://qzenergy.cn";

/**
 * Update document title / description / canonical per page for SEO.
 */
export function useSEO(title: string, description: string, path: string) {
  useEffect(() => {
    document.title = title;

    const ensureMeta = (selector: string, attr: string, name: string) => {
      let el = document.head.querySelector(selector) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      return el;
    };

    ensureMeta('meta[name="description"]', "name", "description").setAttribute(
      "content",
      description,
    );

    let canonical = document.head.querySelector(
      'link[rel="canonical"]',
    ) as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${CANONICAL_ORIGIN}${path}`);
  }, [title, description, path]);
}